export const DATA_UNAVAILABILITY_REASONS = {
  'No Suitable Repository': {
    main: 'Data is not publicly available due to the absence of a suitable repository but are available from the authors upon reasonable request.'
  },
  'Contains Sensitive Information': {
    main: 'Data is not publicly available due to sensitive personal information but are available from the authors upon reasonable request.'
  },
  'Contains Commercially Sensitive Information': {
    main: 'Data is not publicly available due to commercially sensitive information but are available from the authors upon reasonable request.'
  },
  'Legal Restrictions': {
    main: 'Data is not publicly available due to legal restrictions but are available from the authors upon reasonable request.'
  },
  'Third-Party Ownership': {
    main: 'Data is not publicly available due to third-party ownership constraints but are available from the authors upon reasonable request.'
  },
  'Prohibitive Costs': {
    main: 'Data is not publicly available due to prohibitive costs associated with preparation and hosting but are available from the authors upon reasonable request.'
  },
  'Inaccessible Format': {
    main: "Data is not publicly available because they're not in a format accessible or reusable by other researchers but are available from the authors upon reasonable request."
  }
};

export const DATA_UNAVAILABILITY_REASONS_IOPP = {
  'No Suitable Repository': {
    main: 'The data cannot be made publicly available upon publication because no suitable repository exists for hosting data in this field of study. The data that support the findings of this study are available upon reasonable request from the authors.'
  },
  'Contains Sensitive Information': {
    main: 'The data cannot be made publicly available upon publication because they contain sensitive personal information. The data that support the findings of this study are available upon reasonable request from the authors.'
  },
  'Contains Commercially Sensitive Information': {
    main: 'The data cannot be made publicly available upon publication because they contain commercially sensitive information. The data that support the findings of this study are available upon reasonable request from the authors.'
  },
  'Legal Restrictions': {
    main: 'The data cannot be made publicly available upon publication due to legal restrictions preventing unrestricted public distribution. The data that support the findings of this study are available upon reasonable request from the authors.'
  },
  'Third-Party Ownership': {
    main: 'The data cannot be made publicly available upon publication because they are owned by a third party and the terms of use prevent public distribution. The data that support the findings of this study are available upon reasonable request from the authors.'
  },
  'Prohibitive Costs': {
    main: 'The data cannot be made publicly available upon publication because the cost of preparing, depositing and hosting the data would be prohibitive within the terms of this research project. The data that support the findings of this study are available upon reasonable request from the authors.'
  },
  'Inaccessible Format': {
    main: 'The data cannot be made publicly available upon publication because they are not available in a format that is sufficiently accessible or reusable by other researchers. The data that support the findings of this study are available upon reasonable request from the authors.'
  },
  'No New Data': {
    main: 'No new data were created or analysed in this study.'
  },
  Other: {
    main: 'The data that support the findings of this study are available upon reasonable request from the authors.'
  }
};
